<template>
  <section class="p-2">
    <v-card>
      <v-card-text class="pb-0">
        <v-container> </v-container>
        <v-card class="pa-2 bord-color" elevation="0" rounded outlined>
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="0"
            outlined
            width="90px"
          >
            <p class="font-weight-bold">
              <v-icon small class="me-1" color="secondary">mdi-filter</v-icon
              >Filters
            </p>
          </v-sheet>
          <v-row class="ms-1 me-1">
            <v-col cols="12" md="2" lg="2" xs="12">
              <v-autocomplete
                class="rounded"
                v-model="selectedCountry"
                dense
                outlined
                placeholder="Sender Country"
                label="Sender Country"
                :items="country_options"
                item-text="txt"
                item-value="val"
              ></v-autocomplete>
            </v-col>
            <v-btn
              depressed
              small
              class="text-capitalize"
              color="primary"
              outlined
              @click="getMasterData(selectedCountry)"
              >Get Results</v-btn
            >
          </v-row>
        </v-card>
      </v-card-text>
      <v-card-text>
        <v-row class="ms-1 me-1 mt-2">
          <v-btn
            depressed
            small
            class="ms-3 text-capitalize"
            color="primary"
            @click="openFormDialog()"
            ><v-icon small>mdi-content-save-plus-outline</v-icon>Add Master
            Data</v-btn
          >
        </v-row>
        <!-- -------------------------------modal to add category ------------------- -->
        <v-dialog persistent max-width="600px" v-model="dialog">
          <v-card>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-toolbar dark color="#050048" flat dense>
                <span class="subtitleFontsize">{{ formtitle }}</span>
                <v-spacer></v-spacer>
                <v-btn depressed small icon @click="dialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text class="">
                <v-row>
                  <v-col cols="12" md="12">
                    <label class="my-0 mt-3 rounded labelFontsize required">
                      Sending Country
                    </label>
                    <v-autocomplete
                      dense
                      outlined
                      placeholder="Sending Country"
                      disabled
                      :items="country_options"
                      item-text="txt"
                      item-value="val"
                      v-model="parameterdetails.send_country_cd"
                      class="rounded"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <label class="my-0 rounded labelFontsize required">
                      Transaction Type
                    </label>
                    <v-autocomplete
                      dense
                      outlined
                      placeholder="Transaction Type"
                      :items="returnuserTypes"
                      item-text="txt"
                      item-value="val"
                      v-model="parameterdetails.txn_type"
                      class="rounded"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row class="">
                  <v-col cols="12" md="12">
                    <label class="my-0 rounded labelFontsize required">
                      Parameter Type
                    </label>
                    <v-autocomplete
                      placeholder="Parameter Type"
                      dense
                      outlined
                      :items="parametersdataList"
                      @change="
                        getallparametersvalue(parameterdetails.parameter)
                      "
                      v-model="parameterdetails.parameter"
                      class="rounded"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row class="">
                  <v-col cols="12" md="12">
                    <label class="my-0 rounded labelFontsize required">
                      Parameter Values ({{
                        parameterdetails.parameter_value.length > 0
                          ? parameterdetails.parameter_value.length
                          : 0
                      }})
                    </label>
                    <v-autocomplete
                      placeholder="Parameter Values"
                      dense
                      outlined
                      :search-input.sync="searchInput"
                      @change="searchInput = ''"
                      multiple
                      :items="parametersdataValueList"
                      v-model="parameterdetails.parameter_value"
                      class="rounded"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-divider class="ma-0 pa-0"> </v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  depressed
                  small
                  color="primary"
                  @click="onclickNext()"
                  class="text-capitalize"
                >
                  <v-icon small class="me-2"
                    >mdi-content-save-plus-outline</v-icon
                  >Save
                </v-btn>
                <v-btn
                  depressed
                  small
                  color="primary"
                  class="text-capitalize ms-2"
                  @click="onClickBack()"
                  outlined
                >
                  <v-icon small class="me-2">mdi-close-circle-outline</v-icon>
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
        <!-- -------------------------------modal to add category ------------------- -->

        <!-- ------------------------------- to delete the record ------------------- -->
        <v-dialog v-model="dialogDelete" width="500">
          <v-card>
            <v-card-title class="border border-bottom">Delete</v-card-title>
            <v-card-text class="h5 py-3"
              >Are you sure you want to delete this prameter?</v-card-text
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed small color="primary" outlined>
                <v-icon>mdi-check</v-icon>
              </v-btn>
              <v-btn depressed small color="primary" outlined
                ><v-icon>mdi-close</v-icon></v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- -----------------------category table Master Data------------------------- -->
        <v-data-table
          fixed-header
          height="55vh"
          :headers="headers"
          dense
          :search="search"
          class="mt-3 p-1"
          :items="parametersList"
          :loading="isLoading"
          loading-text="Loading... Please wait"
        >
          <template v-slot:item.action="{ item }">
            <v-icon color="grey" class="mr-2" @click="nextpage(item)">
              mdi-chevron-right-circle
            </v-icon>
          </template>

          <template v-slot:item.actions="{ item }">
            <div class="d-flex">
              <v-switch
                v-model="item.is_active"
                height="0px"
                title="Update Status"
                dense
                color="success"
                @change="isactiveupdate(item)"
              ></v-switch>
            </div>
          </template>
        </v-data-table>

        <loading :active="loader" :opacity="0.9" color="#ff6b00" />
      </v-card-text>
    </v-card>
  </section>
</template>
<script>
import alerts from "@/mixins/alerts";
import { Masterdata } from "@/utils/validationCopy.js";
import Loading from "vue-loading-overlay";
import { returnuserTypes } from "@/utils/ConstantDropdowns/index.js";
import commonService from "@/services/CommonService/commonService.js";
import setupService from "@/services/SetupService/setupService.js";
export default {
  mixins: [alerts],
  name: "Master Data",
  data() {
    return {
      ...Masterdata,
      returnuserTypes,
      item: ["Active", "In-Active"],
      dialogDelete: false,
      searchInput: "",
      dialog: false,
      valid: true,
      isLoading: false,
      loader: false,
      country_options: [],
      selectedCountry: "MYS",
      search: "",
      headers: [
        {
          text: "Id",
          value: "id",
          width: 80,
          align: "start",
        },
        { text: "Parameter name", value: "parameter_name" },
        { text: "Parameter Code", value: "parameter_code" },
        { text: "Parameter", value: "parameter" },
        { text: "Txn Type", value: "txn_type" },
        { text: "Actions", value: "actions", sortable: false },
        {
          text: "Navigation",
          value: "action",
          sortable: false,
          width: 100,
          align: "center",
        },
      ],
      parametersList: [],
      editedIndex: -1,
      parametersdataList: [],
      parametersdataValueList: [],
      parameterdetails: {
        send_country_cd: "",
        map_level: "CW",
        parameter_value: [],
        parameter: "",
        txn_type: "IND",
      },
      isclear: false,
      deleteId: "",
      is_active: "",
    };
  },

  components: {
    Loading,
  },
  computed: {
    formtitle() {
      return this.editedIndex === -1 ? "Add" : "Edit";
    },
  },

  mounted() {
    if (this.selectedCountry) {
      this.getMasterData(this.selectedCountry);
    }
    // this.getallMainparameters();
    this.getBeneCountryList();
    this.getallparameters();
  },

  watch: {
    "parameterdetails.txn_type"(val) {
      if (val && this.parameterdetails.parameter) {
        this.parameterdetails.parameter_value = [];
        this.getallparametersvalue(this.parameterdetails.parameter);
      }
    },
  },
  methods: {
    async downloadExcelsheet() {
      if (this.parametersList) {
        this.exportToExcel(
          this.headers,
          this.parametersList,
          "parameters_List"
        );
      }
    },
    onclickNext() {
      console.log(`prametervalues: ${JSON.stringify(this.parameterdetails)}`);
      this.save();
    },

    async getMasterData(country) {
      this.isLoading = true;
      try {
        const response = await setupService.getMasterDataList(country);
        if (response.data.status_code == 200) {
          this.parametersList = response.data.data[0];
          this.isLoading = false;
        } else {
          this.showAlertError(`Failed: ${response.data.message}`);
          this.isLoading = false;
        }
      } catch (e) {
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
        this.isLoading = false;
      }
    },
    async save() {
      this.isLoading = true;
      try {
        const response = await setupService.addMasterData(
          this.parameterdetails
        );
        if (response.data.status_code == 200) {
          this.showAlertSuccess(response.data.message);
          this.isLoading = false;
          this.onClickBack();
          this.getMasterData(this.selectedCountry);
        } else {
          this.showAlertError(`Failed: ${response.data.message}`);
          this.isLoading = false;
        }
      } catch (e) {
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
        this.isLoading = false;
      }
    },
    async isactiveupdate(item) {
      item.is_active ? false : true;
      this.isLoading = true;
      try {
        const response = await setupService.updatemappingStatus({
          parameter: item.parameter,
          country: item.send_country_cd,
          map_level: "CW",
          is_active: item.is_active,
          payout_partner_id: null,
          map_id: null,
        });
        if (response.data.status_code == 200) {
          this.showAlertSuccess(response.data.message);
          this.isLoading = false;
          this.getMasterData(this.selectedCountry);
        } else {
          this.showAlertError(`Failed: ${response.data.message}`);
          this.isLoading = false;
        }
      } catch (e) {
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
        this.isLoading = false;
      }
    },

    openFormDialog() {
      this.dialog = true;
      this.editedIndex = -1;
      (this.parameterdetails = {
        send_country_cd: "",
        map_level: "CW",
        parameter_value: [],
        parameter: "",
        txn_type: "IND",
      }),
        (this.parameterdetails.send_country_cd = this.selectedCountry);
    },
    editItem() {
      this.editedIndex = 1;
      this.dialog = true;
    },

    onClickBack() {
      this.dialog = false;
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    async getallparameters() {
      this.isLoading = true;
      try {
        const responseData = await setupService.getParameters();
        this.isLoading = false;
        if (responseData.data.status_code === 200) {
          this.parametersdataList = responseData.data.data.map((ele) => {
            return {
              text: ele.parameter_name,
              value: ele.id,
            };
          });
          console.log("getallparameters", responseData);
        }
      } catch (e) {
        this.isLoading = false;
        console.error(e);
      }
    },
    async getallMainparameters() {
      this.isLoading = true;
      try {
        const responseData = await setupService.getallMainparameters({
          map_level: "CW",
        });
        this.isLoading = false;
        if (responseData.data.status_code === 200) {
          this.parametersdataList = responseData.data.data.map((ele) => {
            return {
              text: ele.parameter_name,
              value: ele.id,
            };
          });
          console.log("getallparameters", responseData);
        }
      } catch (e) {
        this.isLoading = false;
        console.error(e);
      }
    },
    async getallparametersvalue(id) {
      this.loader = true;
      try {
        const responseData = await setupService.getParametersValuesUsertype({
          parameter_id: id,
          user_type: this.parameterdetails.txn_type,
        });
        this.loader = false;
        if (responseData && responseData.data.status_code == 200) {
          this.parametersdataValueList =
            responseData.data.data[0].parameter_values.map((ele) => {
              return {
                text: ele.value,
                value: ele.id,
              };
            });
          // this.parametersdataValueList.unshift({
          //   text: "Select All",
          //   value: null,
          // });
        }
      } catch (e) {
        console.log(e);
        this.loader = false;
      }
    },
    async getBeneCountryList() {
      this.isLoading = true;
      try {
        const responseData = await commonService.getCountryBirthList();
        console.log(responseData);
        this.isLoading = false;
        if (responseData.data.status_code === 200) {
          this.country_options = responseData.data.data.map((i) => {
            return {
              txt: i.country_name,
              val: i.iso_alpha3,
            };
          });
        }
        console.log("getBeneCountryList", responseData);
      } catch (e) {
        this.isLoading = false;
        console.error(e);
      }
    },

    nextpage(item) {
      console.log("item " + item);
      this.$router.push({
        name: "Master Data Map Value",
        query: {
          id: item.parameter,
          country: item.send_country_cd,
          map_level: "CW",
          txn_type: item.txn_type,
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
.required:after {
  content: " *";
  color: red;
}
.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}
.bord-color {
  border-radius: 10px;
}
</style>
